mutation NotifyTimeDelete($input: NotifyTimeDeleteInput!) {
  notifyTimeDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
